<template>
  <b-row>
    <b-col cols="12">
      <leave-application-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import LeaveApplicationEditForm from './LeaveApplicationEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    LeaveApplicationEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
